import { BETA_ENGAGEMENT, recordBetaEngagement } from './betaToolbarEligibility';

const RECENT_SEARCHES_KEY = 'shopsmt_recent_searches';
const MAX_RECENT_SEARCHES = 10;

/** @type {Set<(searches: { query: string, searchedAt: number }[]) => void>} */
const subscribers = new Set();

function readJson(key) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === '') {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* localStorage unavailable */
  }
}

function normalizeQuery(query) {
  return typeof query === 'string' ? query.trim() : '';
}

function normalizeKey(query) {
  return normalizeQuery(query).toLocaleLowerCase('en');
}

/**
 * @returns {{ query: string, searchedAt: number }[]}
 */
export function getRecentSearches() {
  const data = readJson(RECENT_SEARCHES_KEY);
  if (!Array.isArray(data)) {
    return [];
  }

  return data.filter(
    (entry) =>
      entry != null
      && typeof entry.query === 'string'
      && normalizeQuery(entry.query) !== ''
      && typeof entry.searchedAt === 'number',
  );
}

function writeRecentSearches(searches) {
  writeJson(RECENT_SEARCHES_KEY, searches);
  for (const callback of subscribers) {
    callback(searches);
  }
}

/**
 * @param {(searches: { query: string, searchedAt: number }[]) => void} callback
 * @returns {() => void}
 */
export function subscribeRecentSearches(callback) {
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
}

/**
 * @param {string} query
 */
export function addRecentSearch(query) {
  const trimmed = normalizeQuery(query);
  if (trimmed === '') {
    return;
  }

  const key = normalizeKey(trimmed);
  const existing = getRecentSearches().filter(
    (entry) => normalizeKey(entry.query) !== key,
  );

  writeRecentSearches([
    { query: trimmed, searchedAt: Date.now() },
    ...existing,
  ].slice(0, MAX_RECENT_SEARCHES));
  recordBetaEngagement(BETA_ENGAGEMENT.SEARCH);
}

/**
 * @param {string} query
 */
export function removeRecentSearch(query) {
  const key = normalizeKey(query);
  if (key === '') {
    return;
  }

  const next = getRecentSearches().filter(
    (entry) => normalizeKey(entry.query) !== key,
  );
  writeRecentSearches(next);
}
